import { spriteUrl } from '@spacegame/assets';

/**
 * Composes 1–3 resource sprites into a shop card's hero art — an overlapping
 * cluster for bundles (e.g. a Chronos crystal in front of a Titan ingot),
 * a single centred icon for plain packs. Mirrors EntityArt.tsx's pattern but
 * inline-sized rather than absolute-fill, since a shop card's art plate holds
 * a composition, not one full-bleed render.
 */
export function shopProductArt(spriteIds: string[], label: string) {
  return (
    <div className="flex items-center">
      {spriteIds.map((id, i) => {
        const url = spriteUrl(id);
        if (!url) return null;
        return (
          <img
            key={id}
            src={url}
            alt={i === 0 ? label : ''}
            loading="lazy"
            className="h-16 w-16 object-contain drop-shadow-[0_4px_10px_rgb(0_0_0_/_0.5)]"
            style={i > 0 ? { marginLeft: -18, zIndex: spriteIds.length - i } : { zIndex: spriteIds.length }}
          />
        );
      })}
    </div>
  );
}
